import styled from "styled-components";

export const DesktopLayout = styled.div`
  display: flex;
  width: 100%;
  min-width: 768px;
  height: calc(100vh - 88px);
  background: #f4f6fb;
`;

export const DesktopContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;
